 const baseURL="https://api.zenrise.io/v1/"
//const baseURL="http://localhost:8080/v1/"

export default baseURL;
